import { css } from 'styled-components';

/* Общие кнопки */
const buttonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 48px;
  padding: 0.9rem 1.6rem;
  border-radius: 999px;
  font-family: var(--font-sans);
  font-size: var(--fz-sm);
  font-weight: 600;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid transparent;
  transition: var(--transition);
  white-space: nowrap;

  &:after {
    display: none !important;
  }
`;

const primaryButton = css`
  ${buttonBase};
  color: #ffffff;
  background: var(--gradient);
  box-shadow: 0 18px 40px -22px rgba(86, 112, 246, 0.9);

  &:hover,
  &:focus,
  &:active {
    outline: none;
    transform: translateY(-2px);
    box-shadow: 0 26px 50px -22px rgba(86, 112, 246, 0.95);
  }
`;

const secondaryButton = css`
  ${buttonBase};
  color: var(--text);
  background: var(--paper);
  border-color: var(--line);

  &:hover,
  &:focus,
  &:active {
    outline: none;
    transform: translateY(-2px);
    border-color: var(--blue);
    color: var(--blue);
    box-shadow: var(--shadow-soft);
  }
`;

const darkButton = css`
  ${buttonBase};
  color: var(--text);
  background: #ffffff;

  &:hover,
  &:focus,
  &:active {
    outline: none;
    transform: translateY(-2px);
    box-shadow: 0 20px 44px -22px rgba(0, 0, 0, 0.6);
  }
`;

const outlineButton = css`
  ${buttonBase};
  color: var(--on-dark);
  background: transparent;
  border-color: var(--on-dark-line-strong);

  &:hover,
  &:focus,
  &:active {
    outline: none;
    transform: translateY(-2px);
    border-color: var(--blue-bright);
    color: #ffffff;
    background: rgba(86, 112, 246, 0.14);
  }
`;

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  container: css`
    width: 100%;
    max-width: var(--container);
    margin: 0 auto;
    padding: 0 32px;

    @media (max-width: 768px) {
      padding: 0 24px;
    }
    @media (max-width: 480px) {
      padding: 0 20px;
    }
  `,

  section: css`
    position: relative;
    width: 100%;
    padding: 110px 0;

    @media (max-width: 768px) {
      padding: 80px 0;
    }
    @media (max-width: 480px) {
      padding: 64px 0;
    }
  `,

  eyebrow: css`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 18px;
    color: var(--blue);
    font-family: var(--font-mono);
    font-size: var(--fz-xs);
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  `,

  card: css`
    position: relative;
    border: 1px solid var(--line);
    border-radius: var(--radius-lg);
    background: var(--paper);
    box-shadow: var(--shadow-soft);
    transition: var(--transition);
  `,

  link: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: var(--transition);
    &:hover,
    &:active,
    &:focus {
      color: var(--blue);
      outline: 0;
    }
  `,

  inlineLink: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    position: relative;
    transition: var(--transition);
    color: var(--blue);
    &:hover,
    &:focus,
    &:active {
      color: var(--blue);
      outline: 0;
      &:after {
        width: 100%;
      }
      & > * {
        color: var(--blue) !important;
        transition: var(--transition);
      }
    }
    &:after {
      content: '';
      display: block;
      width: 0;
      height: 1px;
      position: relative;
      bottom: 0.37em;
      background-color: var(--blue);
      transition: var(--transition);
      opacity: 0.5;
    }
  `,

  primaryButton,
  secondaryButton,
  darkButton,
  outlineButton,

  /* Совместимость со старыми именами */
  button: primaryButton,
  bigButton: primaryButton,
  smallButton: css`
    ${primaryButton};
    min-height: 40px;
    padding: 0.65rem 1.1rem;
    font-size: var(--fz-xs);
  `,

  boxShadow: css`
    box-shadow: var(--shadow-card);
    transition: var(--transition);

    &:hover,
    &:focus {
      box-shadow: 0 30px 70px -34px rgba(11, 18, 32, 0.5);
    }
  `,

  fancyList: css`
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: var(--fz-lg);
    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 10px;
      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--blue);
      }
    }
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
};

export default mixins;
